import { render, staticRenderFns } from "./Sure.vue?vue&type=template&id=bcb5d8c8"
import script from "./Sure.vue?vue&type=script&lang=js"
export * from "./Sure.vue?vue&type=script&lang=js"
import style0 from "./Sure.vue?vue&type=style&index=0&id=bcb5d8c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports